module.exports = __webpack_public_path__ + "static/media/logo.985223aa.png";